import BaseApi from './BaseApi'
import { appendRequestParameters } from '@/helpers/Utils'

/**
 * Environment settings.
 * @param {Object, Array, String, Null} params.fleets
 * @param {Object, Array, String, Null} params.organization
 * @param {Object, Array, String, Null} params.organizations
 */

export default class UserApi extends BaseApi {
    async getUsers (params = {
        userName: null,
        email: null,
        firstName: null,
        lastName: null,
        fleets: null,
        organization: null,
        organizations: null,
        page: null,
        perPage: null,
        orderBy: null
    }) {
        const request = new URLSearchParams()

        if (params.page && params.perPage) {
            const skip = (params.page - 1) * params.perPage
            request.append('Skip', skip.toString())
            request.append('Take', params.perPage)
        }

        if (params.fleets) {
            appendRequestParameters('FleetIds', request, params.fleets, 'id')
        }

        if (params.organization) {
            appendRequestParameters('OrganizationId', request, params.organization, 'id')
        }

        if (params.organizations) {
            appendRequestParameters('OrganizationIds', request, params.organizations, 'id')
        }

        if (params.userName) {
            request.append('UserName', `%${params.userName}%`)
        }

        if (params.email) {
            request.append('Email', `%${params.email}%`)
        }

        if (params.firstName) {
            request.append('FirstName', `%${params.firstName}%`)
        }

        if (params.lastName) {
            request.append('LastName', `%${params.lastName}%`)
        }

        if (params.orderBy) {
            request.append('OrderBy', params.orderBy)
        }

        return this.get(`/api/v1.0/users`, request)
    }
    async getUser (id) {
        return this.get(`/api/v1.0/users/${id}`)
    }
    async getOrganizationsToAssign (userId) {
        return this.get(`/api/v1.0/users/${userId}/organizationsToAssing`)
    }
    async createUser (params = {
        userName: null,
        firstName: null,
        lastName: null,
        phoneNumber: null,
        email: null,
        password: null,
        permissions: null,
        roles: null,
        expiresIn: null,
        organizationId: null,
        accessForAllSubOrgs: true,
        ...rest
    }) {
        return this.post('/api/v1.0/users', params)
    }
    async editUser (params = {
        id: null,
        userName: null,
        firstName: null,
        lastName: null,
        phoneNumber: null,
        email: null,
        permissions: null,
        roles: null,
        expiresIn: null,
        organizationId: null,
        accessForAllSubOrgs: true,
        ...rest
    }) {
        return this.put('/api/v1.0/users', params)
    }
    async deleteUser (id) {
        return this.delete(`/api/v1.0/users/${id}`)
    }
    async assignUserToFleets (userId, fleetIds) {
        return this.put(`/api/v1.0/users/assignFleets`, {
            userFleetIds: {
                userId,
                fleetIds
            }
        })
    }
    async unassignUserFromFleets (userId, fleetIds) {
        return this.put(`/api/v1.0/users/unassignFleets`, {
            userFleetIds: {
                userId,
                fleetIds
            }
        })
    }
    async assignUserToOrganizations (userId, organizationIds) {
        return this.put(`/api/v1.0/users/assignOrganizations`, {
            userOrganizationsIds: {
                userId,
                organizationIds
            }
        })
    }
    async unassignUserFromOrganizations (userId, organizationIds) {
        return this.put(`/api/v1.0/users/unassignOrganizations`, {
            userOrganizationsIds: {
                userId,
                organizationIds
            }
        })
    }
}
